import { COVERAGE_URL } from 'features/coverage/paths'
import { projectPath } from 'routes/builders'

// Coverage owns the parent segment; these segments sit under it.
export const SOCIAL_TOPICS_SEGMENT = 'social-topics'
export const NEW_SOCIAL_TOPIC_SEGMENT = 'new'
export const TOPIC_UUID_PARAM = 'topicUuid'
export const SOCIAL_TOPIC_SEGMENT = `:${TOPIC_UUID_PARAM}`

/** The `feature` the backend names a social topic annotation with. */
export const SOCIAL_TOPICS_ANNOTATION_FEATURE = 'social-topics'

export const buildNewSocialTopicPath = (projectId: string): string =>
  `${projectPath(projectId)}/${COVERAGE_URL}/${SOCIAL_TOPICS_SEGMENT}/${NEW_SOCIAL_TOPIC_SEGMENT}`

export const buildSocialTopicPath = (
  projectId: string,
  topicUuid: string,
): string =>
  `${projectPath(projectId)}/${COVERAGE_URL}/${SOCIAL_TOPICS_SEGMENT}/${topicUuid}`
